import { z } from 'zod'

export const GUEST_TAG_LIMIT = 3

const GUEST_STORED_TAG_LIMIT = 10

const GuestTagSchema = z
  .object({
    name: z.string().trim().min(1).max(100),
    color: z.string().regex(/^#[0-9a-f]{6}$/i),
  })
  .strict()

export type GuestTag = Readonly<z.infer<typeof GuestTagSchema>>

export function normalizeGuestTags(value: unknown): readonly GuestTag[] {
  if (!Array.isArray(value)) return []

  const tags = new Map<string, GuestTag>()
  for (const entry of value) {
    const result = GuestTagSchema.safeParse(entry)
    if (!result.success) continue
    const key = result.data.name.toLowerCase()
    if (!tags.has(key)) tags.set(key, result.data)
    if (tags.size === GUEST_STORED_TAG_LIMIT) break
  }
  return Array.from(tags.values())
}

export function haveEqualGuestTags(
  left: readonly GuestTag[] | undefined,
  right: readonly GuestTag[] | undefined,
): boolean {
  if (left === undefined || right === undefined) return left === right
  return (
    left.length === right.length &&
    left.every(
      (tag, index) =>
        tag.name === right[index]?.name && tag.color === right[index]?.color,
    )
  )
}
